<template>
    <div class="main">
        <div class="container">
            <div class="card">
                <p>You do not have access to view this page</p>
                 <label><router-link :to="{ path: '/portal' }">Back to Portal</router-link></label>
            </div>
        </div>
    </div>
</template>
<script>
export default{
  name: 'noacess',
  methods:{
      changeBackgroud(){
        document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)"
      }
  },
  created(){
      this.changeBackgroud()   
  }
}
</script>

<style scoped>
    .main {
        text-align: center;
        font-size: 48px;
        font-weight: 600;
        margin: 120px;
    }
</style>